import {resource} from '@albert-io/json-api-framework/request/builder';
import {genericMandarkRequest} from 'resources/mandark.resource';
import sessionStore from 'client/Session/SessionStore';

export const saveMedia = (payload, guessDraftId, mediaCategory) => {
  const userId = sessionStore.getUserId();
  const query = resource('media_v1').mandarkEndpoint(['media_v1', 'draft_guess']).done();
  return genericMandarkRequest('post', query, {
    data: {
      attributes: {
        media: payload.media,
        expected_media_category: mediaCategory
      },
      relationships: {
        draft_guess_v1: {
          data: {
            id: guessDraftId,
            type: 'draft_guess_v1'
          }
        },
        user_v2: {
          data: {
            id: userId,
            type: 'user_v2'
          }
        }
      }
    }
  });
};

export const getMedia = (mediaId) => {
  const query = resource('media_v1').mandarkEndpoint(['media_v1', mediaId]).done();
  return genericMandarkRequest('get', query);
};

export const deleteMedia = (mediaId, guessDraftId) => {
  const userId = sessionStore.getUserId();
  const query = resource('media_v1').mandarkEndpoint(['media_v1', mediaId, 'draft_guess']).done();
  return genericMandarkRequest('delete', query, {
    data: {
      id: mediaId,
      type: 'media_v1',
      relationships: {
        draft_guess_v1: {
          data: {
            id: guessDraftId,
            type: 'draft_guess_v1'
          }
        },
        user_v2: {
          data: {
            id: userId,
            type: 'user_v2'
          }
        }
      }
    }
  });
};

export const deleteGuessMedia = (mediaId, guessId) => {
  const userId = sessionStore.getUserId();
  const query = resource('media_v1').mandarkEndpoint(['media_v1', mediaId, 'guess']).done();
  return genericMandarkRequest('delete', query, {
    data: {
      id: mediaId,
      type: 'media_v1',
      relationships: {
        guess_v1: {
          data: {
            id: guessId,
            type: 'guess_v1'
          }
        },
        user_v2: {
          data: {
            id: userId,
            type: 'user_v2'
          }
        }
      }
    }
  });
};
